import React from 'react';
import './App.css';
import { BrowserRouter as Router, Link, Switch, Route } from 'react-router-dom';
import Upload from './pages/Upload2023.js';
import Upload2023 from './pages/Upload2023.js';
import Home from './pages/Home.js';
function App() {
    return (
        <div className="container">
            <Router>
                <nav className="nav">
                    <div className="nav-brand"></div>
                    <ul className="nav-items">
                    </ul>
                </nav>
                <Switch>
                    <Route component={Upload} path="/" exact />
                    <Route component={Upload2023} path="/2023" />
                    <Route component={Home} path="/home" />
                </Switch>
            </Router>
        </div>
    );
}

export default App;
